import React from 'react';
import {
  CommentConversion,
  Content,
  ContentType,
} from '@amzn/awscat-pattern-library-service-model';
import SingleToMultiPageConverter from './SingleToMultiPageConverter';
import MultiToSinglePageConverter from './MultiToSinglePageConverter';
import DefaultConverter from './DefaultConverter';
import { ContentTypeToPageTypeMap, TemplatePageType } from '../../utils/SelectableOptions';

interface Props {
  content: Content;
  onDismiss?: () => void;
  onError: (errorMsg?: string) => void;
  onSuccess: (updatedContent: Content, commentConversions?: CommentConversion[]) => void;
  toContentType: ContentType;
}

const ContentConverter: React.FunctionComponent<Props> = (props: Props) => {
  const { content, onDismiss, onError, onSuccess, toContentType } = props;
  const { contentType: fromContentType } = content.contentMetadata;
  const fromPageType = ContentTypeToPageTypeMap.get(fromContentType);
  const toPageType = ContentTypeToPageTypeMap.get(toContentType);

  if (fromPageType === toPageType) {
    return (
      <DefaultConverter
        content={content}
        onDismiss={onDismiss}
        onError={onError}
        onSuccess={onSuccess}
        toContentType={toContentType}
      />
    );
  } else if (toPageType === TemplatePageType.SinglePage) {
    return (
      <MultiToSinglePageConverter
        content={content}
        onDismiss={onDismiss}
        onError={onError}
        onSuccess={onSuccess}
        toContentType={toContentType}
      />
    );
  } else {
    return (
      <SingleToMultiPageConverter
        content={content}
        onDismiss={onDismiss}
        onError={onError}
        onSuccess={onSuccess}
        toContentType={toContentType}
      />
    );
  }
};

export default ContentConverter;
